export default {
    PAGE: {
        REBFLAECHEN: {
            REBFLAECHEN_INDEX: '/rebflaechen',
            REBFLAECHEN_VORJAHR: '/rebflaechen-vorjahr',
            EZZ_AUSWAHL: '/ezz-auswahl',
            EZZ_AUSWAHL_VORJAHR: '/ezz-auswahl-vorjahr',
            EZZ_FLAECHEN: '/ezz-flaechen/:erzeuger_nr?',
            EZZ_FLAECHEN_VORJAHR: '/ezz-flaechen-vorjahr/:erzeuger_nr?',
            RODUNG_MELDEN: '/rebflaeche/:rebflaeche_id/rodung-melden',
            ABGANG_MELDEN: '/rebflaeche/:rebflaeche_id/abgang-melden',
            PFLANZUNG_MELDEN: '/rebflaeche/:rebflaeche_id/pflanzung-melden',
            SONSTIGES_MELDEN: '/rebflaeche/:rebflaeche_id/sonstiges-melden',
            UNBESTOCKTER_ZUGANG_MELDEN: '/rebflaeche/unbestockter-zugang-melden',
            BESTOCKTER_ZUGANG_MELDEN: '/rebflaeche/bestockter-zugang-melden',
            MELDUNG_RUECKGAENGIG: '/rebflaeche/:rebflaeche_id/meldung-rueckgaengig',
            TEILUNG_MELDEN: '/rebflaeche/:rebflaeche_id/teilung-melden',
            VERMARKTERWECHSEL_MELDEN: '/rebflaeche/:rebflaeche_id/vermarkterwechsel-melden',
            ZUSAMMENFUEHRUNG_MELDEN: '/rebflaeche/:rebflaeche_id/zusammenfuehrung-melden',
            REBFLAECHE_DETAILS: '/rebflaeche/:rebflaeche_id/details',
            REBFLAECHE_DETAILS_VORJAHR: '/rebflaeche/:rebflaeche_id/details-vorjahr',
            TAN_ANFORDERUNG: '/rebflaeche/tan-anforderung',
        },
    },
    API: {
        REBFLAECHEN: {
            FLAECHE: '/betrieb/:betrieb_nr/rv/rebflaeche/:status\\?vorjahr=:vorjahr?',
            FLAECHE_EZZ: '/betrieb/:betrieb_nr/rv/ezz-flaeche/:status\\?vorjahr=:vorjahr?',
            EZZ_AUSWAHL: '/betrieb/:betrieb_nr/rv/erzeuger-auswahl',
            EZZ_AUSWAHL_VORJAHR: '/betrieb/:betrieb_nr/rv/erzeuger-auswahl/vorjahr',
            MELDUNG_CREATE: '/betrieb/:betrieb_nr/rv/meldung/create\\?rv_token=:token?',
            MELDUNG_CHECK: '/betrieb/:betrieb_nr/rv/meldung/check/check',
            SONSTIGE_MELDUNG_CREATE: '/betrieb/:betrieb_nr/rv/meldung/create-sonstige\\?rv_token=:token?',
            SONSTIGE_MELDUNG_CHECK: '/betrieb/:betrieb_nr/rv/meldung/check/sonstige',
            ZUGANG_MELDUNG_CREATE: '/betrieb/:betrieb_nr/rv/meldung/create-zugang\\?rv_token=:token?',
            ZUGANG_MELDUNG_CHECK: '/betrieb/:betrieb_nr/rv/meldung/check/zugang',
            REBSORTE: '/rebflaeche/rebsorte',
            UNTERLAGE: '/rebflaeche/unterlage',
            UNTERLAGE_EINGESCHRAENKT: '/rebflaeche/unterlage?filter%5Bzulassung_id%5D=Z',
            FLAECHE_VIEW: '/betrieb/:betrieb_nr/rv/rebflaeche/:flaeche_id\\?vorjahr=:vorjahr?',
            MELDUNG_RUECKGAENGIG: '/betrieb/:betrieb_nr/rv/meldung/storno/:meldung_id\\?rv_token=:token?',
            MELDUNG_RUECKGAENGIG_CHECK: '/betrieb/:betrieb_nr/rv/meldung/check/storno/:meldung_id',
            EXCEL_BIG: '/betrieb/:betrieb_nr/rv/rebflaeche/big-excel-export',
            EXCEL_SMALL: '/betrieb/:betrieb_nr/rv/rebflaeche/small-excel-export',
            CSV: '/betrieb/:betrieb_nr/rv/rebflaeche/csv-export',
            EXCEL_BIG_EZZ: '/betrieb/:betrieb_nr/rv/ezz-flaeche/big-excel-export',
            EXCEL_SMALL_EZZ: '/betrieb/:betrieb_nr/rv/ezz-flaeche/small-excel-export',
            CSV_EZZ: '/betrieb/:betrieb_nr/rv/ezz-flaeche/csv-export',
            QUITTUNG: '/betrieb/:betrieb_nr/rv/rebflaeche/meldung-quittung',
            MELDEFORMULAR: '/betrieb/:betrieb_nr/rv/rebflaeche/meldung-formular',
            REBFLAECHENVERZEICHNIS: '/betrieb/:betrieb_nr/rv/rebflaeche/meldung-rebflaechenverzeichnis',
            FLAECHE_ZUSAMMENFUEHRUNG: '/betrieb/:betrieb_nr/rv/rebflaeche',
            VERSIONEN: '/betrieb/:betrieb_nr/rv/rebflaeche/versionen/:flaeche_id\\?vorjahr=:vorjahr?',
            TAN_GENERATE: '/betrieb/:betrieb_nr/rv/tan/generate',
            TAN_VALIDATE: '/betrieb/:betrieb_nr/rv/tan/validate/:tan/:tan_id',
            TAN_RESEND: '/betrieb/:betrieb_nr/rv/tan/send/:token',
            BETRIEB_INFOS: '/betrieb/:betrieb_nr/rv/betrieb-infos',
            BETRIEB_INFOS_VORJAHR: '/betrieb/:betrieb_nr/rv/betrieb-infos/vorjahr',
            ZUGANG_TREFFER: '/betrieb/:betrieb_nr/rv/meldung/check/treffer-zugang',
            ZUSAMMENFASSUNG: '/betrieb/:betrieb_nr/rv/rebflaeche/pdf-zusammenfassung',
            AUSZUG_MIT_HANGNEIGUNG: '/betrieb/:betrieb_nr/rv/rebflaeche/pdf-auszug-mit-hangneigung',
            AUSZUG_MIT_HANGNEIGUNG_EZZ: '/betrieb/:betrieb_nr/rv/ezz-flaeche/pdf-auszug-mit-hangneigung',
        },
    },
    CMSFILE: {
        ERLAEUTERUNGEN_ANSICHT_REBFLAECHEN: '/Erlaeuterungen_Ansicht_Rebflaechen.pdf',
        ERLAEUTERUNGEN_REBFLAECHENVERZEICHNIS: '/Erlaeuterungen_Rebflaechenverzeichnis.pdf',
        ERLAEUTERUNGEN_AUSZUG_DER_GEAENDERTEN_REBFLAECHEN: '/Erlaeuterungen_Auszug_der_geaenderten_Rebflaechen.pdf',
        DATENSATZBESCHREIBUNG_EXPORT_FA_EXCEL_KLEIN: '/Datensatzbeschreibung_Export_RFVneu_Excel_klein.pdf',
        DATENSATZBESCHREIBUNG_EXPORT_FA_EXCEL_GROSS: '/Datensatzbeschreibung_Export_RFVneu_Excel_gross.pdf',
        DATENSATZBESCHREIBUNG_EXPORT_FA_TEXT: '/Datensatzbeschreibung_Export_RFVneu_Text.pdf',
    },
};
